/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "workflowactionpending",
	init: init,
	listeners: listeners
});

function listeners(){
	return {
		"workflowactions:updated": handle_actions_updated
	};
}

function init(){
	this.push([]);
}

function handle_actions_updated(actions){
	this.push(actions.sort(sortActions));
}

function sortActions(a, b) {
	var actionLabelA = a.action;
	var actionLabelB = b.action;

	var schemaA = a.ongoingWorkflow.workflow.actions[actionLabelA];
	var schemaB = b.ongoingWorkflow.workflow.actions[actionLabelB];

	var priorityA = schemaA?.priority || 0;
	var priorityB = schemaB?.priority || 0;

	var delta = priorityA - priorityB;

	if(delta) return delta;

	return (new Date(a.updated_at).getTime()) - (new Date(b.updated_at).getTime());
}